module.exports = __webpack_public_path__ + "img/jetrodder_parked.61b8b42b.svg";